import { msg } from "@lingui/core/macro";
import type { MessageDescriptor } from "@lingui/core";

import type { MatchMetric } from "./MatchMetric";

// Названия метрик матча. `Record` по union из контракта: новая метрика не соберётся без текста.
export const METRIC_LABELS: Record<MatchMetric, MessageDescriptor> = {
  souls_per_min: msg({ id: "analysis.metric.souls_per_min", message: "Souls per minute" }),
  neutral_damage_per_min: msg({
    id: "analysis.metric.neutral_damage_per_min",
    message: "Damage to neutral camps per minute",
  }),
  buffs_per_min: msg({
    id: "analysis.metric.buffs_per_min",
    message: "Permanent bonuses",
  }),
  first_buff_time: msg({ id: "analysis.metric.first_buff_time", message: "First permanent bonus" }),
  cs_share: msg({ id: "analysis.metric.cs_share", message: "Last hits on nearby troopers" }),
  hero_damage_per_min: msg({
    id: "analysis.metric.hero_damage_per_min",
    message: "Hero damage per minute",
  }),
  accuracy: msg({ id: "analysis.metric.accuracy", message: "Accuracy" }),
  crit_rate: msg({ id: "analysis.metric.crit_rate", message: "Headshots" }),
  objective_damage_per_min: msg({
    id: "analysis.metric.objective_damage_per_min",
    message: "Objective damage per minute",
  }),
  kill_participation: msg({
    id: "analysis.metric.kill_participation",
    message: "Kill participation",
  }),
  parry_rate: msg({ id: "analysis.metric.parry_rate", message: "Successful parries" }),
  damage_taken_per_min: msg({
    id: "analysis.metric.damage_taken_per_min",
    message: "Damage taken per minute",
  }),
  time_dead_share: msg({ id: "analysis.metric.time_dead_share", message: "Time spent dead" }),
  unspent_souls: msg({ id: "analysis.metric.unspent_souls", message: "Souls waiting to be spent" }),
  unspent_ap: msg({ id: "analysis.metric.unspent_ap", message: "Unspent ability points" }),
};
